export function setupFeedbackPanel({
  elements
}) {
  const buildContributeUrl = () => new URL("/contributions/new", window.location.origin).toString();

  const openFeedbackPanel = () => {
    if (elements.contributeLink) {
      elements.contributeLink.href = buildContributeUrl();
    }

    elements.panel?.classList.remove("hidden");
    elements.panel?.setAttribute("aria-hidden", "false");

    if (elements.closeButton) {
      elements.closeButton.focus();
    } else if (elements.contributeLink) {
      elements.contributeLink.focus();
    }
  };

  const closeFeedbackPanel = () => {
    const shouldRestoreFocus = elements.panel?.contains(document.activeElement);
    elements.panel?.classList.add("hidden");
    elements.panel?.setAttribute("aria-hidden", "true");
    if (shouldRestoreFocus) elements.toggleButton?.focus();
  };

  elements.toggleButton?.addEventListener("click", () => {
    if (elements.panel?.classList.contains("hidden")) {
      openFeedbackPanel();
    } else {
      closeFeedbackPanel();
    }
  });

  elements.closeButton?.addEventListener("click", closeFeedbackPanel);

  return {
    buildContributeUrl,
    openFeedbackPanel,
    closeFeedbackPanel
  };
}
